<template>
  <v-container class="text-center">
    <h2 class="display-2 font-weight-bold mb-3">WELCOME</h2>

    <v-responsive class="mx-auto mb-8" width="56">
      <v-divider class="mb-1"></v-divider>

      <v-divider></v-divider>
    </v-responsive>

    <v-responsive class="mx-auto title font-weight-light" max-width="720">
      <p class="title">Okay, let's get you started with GroupBot!</p>
      <p>
        First things first:
        <br />We need you to configure your <span class="font-weight-bold">account, subscription</span> and your
        <span class="font-weight-bold">bot</span>!
      </p>
    </v-responsive>

    <v-avatar
      class="elevation-12 my-4"
      :color="$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-5'"
      size="120"
    >
      <v-img contain max-height="80%" :src="getLogo()"></v-img>
    </v-avatar>

    <v-responsive class="mx-auto title font-weight-light" max-width="720">
      <p>To configure the app, use the account menu and configure your account and bot.</p>
      <v-btn
        fab
        large
        @click="accountMenuSet(true)"
        color="primary"
        title="Account menu"
      >
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      <p class="mt-2" v-if="accountRedirect">We'll redirect you there automatically...</p>
      <v-progress-linear :value="((timer - timeLeft)/timer)*100" v-if="accountRedirect"></v-progress-linear>
    </v-responsive>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    timer: 20,
    timePassed: 0,
    timerInterval: null
  }),
  mounted() {
    if (this.accountRedirect) {
      this.startTimer();
    }
  },
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    ...mapGetters("app", ["accountRedirect"]),
    timeLeft() {
      return this.timer - this.timePassed;
    },
    isAccountConfigured() {
      return this.user && this.user.account && this.user.account.name
    }
  },
  methods: {
    ...mapActions("app", ["accountMenuSet", "accountRedirectSet"]),
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    timesUp() {
      clearInterval(this.timerInterval);
      this.accountRedirectSet(false);
      if (!this.isAccountConfigured) {
        this.$router.push({ name: "account" });
      } else {
        this.$router.push({ name: "bot" });
      }
    },
    getLogo() {
      var images = require.context("@/assets/", false, /\.png$/);
      return images(
        this.$vuetify.theme.dark
          ? "./GroupBot-Logo-Dark.png"
          : "./GroupBot-Logo-Light.png"
      );
    }
  },
  watch: {
    timeLeft(tl) {
      if (tl === 0) this.timesUp();
    }
  }
};
</script>